import index from './'
import verificar from './verificar'

export default [
  {
    path: '/register',
    name: 'register.index',
    component: index
  },
  {
    path: '/verificar',
    name: 'register.verificar',
    component: verificar
  }
]



// WEBPACK FOOTER //
// ./src/features/register/routes.js